export default "__VITE_PUBLIC_ASSET__73fe6c7c__"